/**
 * Hack for Search & Filter Pro form on search results
 * Since we combined post types for posts/pages and trad. protocols/protocols via WP Hook, it doesn't
 * stay selected once the results have been filtered by those combined post types. We're using
 * JS instead that checks the post type in an attribute set on the search results wrapper.
 *
 * This only works so long as the search results form is NOT using Ajax.
 */

(function( $ ) {
		'use strict';

		function ready( fn ) {
			if ( document.attachEvent
				 ? document.readyState === 'complete'
				 : document.readyState !== 'loading' ) {
				fn();
			} else {
				document.addEventListener( 'DOMContentLoaded', fn );
			}
		}

		ready( appendAdvancedSearchBtn );
		ready( checkContentTypeInSearch );
		ready( requireDateRange );
		ready( requireSearchTerm );
		ready( setSearchDateQuery );
		ready( toggleAdvancedSearch );
		ready( togglePinnedResults );
		ready( togglePdfSearch );

		function appendAdvancedSearchBtn() {
			let searchForm = document.querySelector( '.searchandfilter .sf-field-search h4' );

			if ( searchForm === null ) {
				return;
			}

			let createBtn = document.createElement( 'button' );

			createBtn.setAttribute( 'id', 'btn-toggle-advanced-search' );
			createBtn.setAttribute( 'type', 'button' );
			createBtn.innerHTML = `Advanced Search <span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span>`;

			searchForm.after( createBtn );
		}

		function requireDateRange() {
			let firstDateField                         = $( '.sf_date_field li:first-child .sf-datepicker' ),
				secondDateField                        = $( '.sf_date_field li:last-child .sf-datepicker' ),
				firstDateEmpty = true, secondDateEmpty = true;

			firstDateField.datepicker( {
										   dateFormat: 'mm/dd/yy',
										   onClose   : function( date ) {
											   checkDateRangeValues( 'first', date );
											   requireDateFields( firstDateEmpty, secondDateEmpty );
										   }
									   } );

			secondDateField.datepicker( {
											dateFormat: 'mm/dd/yy',
											onClose   : function( date ) {
												checkDateRangeValues( 'second', date );
												requireDateFields( firstDateEmpty, secondDateEmpty );
											}
										} );

			function checkDateRangeValues( dateFieldType, dateFieldValue ) {
				if ( dateFieldType === 'first' ) {
					if ( dateFieldValue !== '' ) {
						firstDateEmpty = false;
					} else {
						firstDateEmpty = true;
					}
				}

				if ( dateFieldType === 'second' ) {
					if ( dateFieldValue !== '' ) {
						secondDateEmpty = false;
					} else {
						secondDateEmpty = true;
					}
				}
			}

			function requireDateFields( firstDateEmpty, secondDateEmpty ) {
				if ( (firstDateEmpty === true && secondDateEmpty === false
					 ) || (firstDateEmpty === false && secondDateEmpty === true
					 ) ) {
					firstDateField.attr( 'required', 'required' );
					firstDateField.addClass( 'date-fields-required' );
					secondDateField.attr( 'required', 'required' );
					secondDateField.addClass( 'date-fields-required' );
				} else {
					firstDateField.removeAttr( 'required', 'required' );
					firstDateField.removeClass( 'date-fields-required' );
					secondDateField.removeAttr( 'required', 'required' );
					secondDateField.removeClass( 'date-fields-required' );
				}
			}

		}

		function requireSearchTerm() {
			let searchField = document.querySelector( '.sf-field-search input' );
			searchField.setAttribute( 'required', 'required' );
		}

		function checkContentTypeInSearch() {
			let searchResultsWrapper = document.getElementById( 'search-results-wrapper' );

			if ( !searchResultsWrapper ) {
				return;
			}

			let resultsContentType = searchResultsWrapper.getAttribute( 'data-content-type' );

			if ( !resultsContentType ) {
				return;
			}

			let contentTypeField = document.querySelector( '.sf-field-post_type .sf-input-select' );

			if ( !contentTypeField ) {
				return;
			}

			if ( resultsContentType === 'post page' ) {
				contentTypeField.value = 'post,page';
			}

			if ( resultsContentType === 'protocol traditional-protocol' ) {
				let contentTypeField = document.querySelector( '.sf-field-post_type .sf-input-select' );

				if ( !contentTypeField ) {
					return;
				}

				contentTypeField.value = 'protocol,traditional-protocol';
			}
		}

		function setSearchDateQuery() {
			let triggerDateQueryReset = document.getElementById( 'btn-older-search-results' );

			if ( triggerDateQueryReset === null ) {
				return;
			}

			triggerDateQueryReset.addEventListener( 'click', function( e ) {
				e.preventDefault();

				let currentSearchUrl = new URL( ISDA_Main.pluginSearchUrl ),
					searchParams     = currentSearchUrl.searchParams,
					encodedDateRange = ISDA_Main.oldestPostDate + '+' + ISDA_Main.dateSixMonthsFromToday;

				searchParams.set( 'post_date', encodedDateRange );

				// change the search property of the main url, send back to "all" tab
				currentSearchUrl.search = searchParams.toString();
				window.location.href = decodeURIComponent( currentSearchUrl.toString() );
			} );

		}

		function togglePdfSearch(){
			let triggerSearchToggle = document.getElementById( 'search-pdf-toggle' ),
				searchForm          = document.querySelector( '.searchandfilter' );

			if ( triggerSearchToggle === null ) {
				return;
			}

			triggerSearchToggle.addEventListener( 'change', function( e ) {
				e.preventDefault();

				let currentSearchUrl = new URL( ISDA_Main.pluginSearchUrl ),
					searchParams     = currentSearchUrl.searchParams;

				if(searchParams.has('_sf_pdf') && searchParams.get('_sf_pdf') == 1){
					searchParams.delete( '_sf_pdf' );
				}else{
					searchParams.set( '_sf_pdf', 1 );
				}

				currentSearchUrl.search = searchParams.toString();
				window.location.href = decodeURIComponent( currentSearchUrl.toString() );
			} );
		}

		function toggleAdvancedSearch() {
			let triggerSearchToggle = document.getElementById( 'btn-toggle-advanced-search' ),
				searchForm          = document.querySelector( '.searchandfilter' );

			if ( triggerSearchToggle === null ) {
				return;
			}

			//keep advanced search open if it was open before page refresh
			if ( localStorage.advancedSearchActive === 'yes' || document.getElementById( 'btn-older-search-results' ) === null ) {
				searchForm.classList.add( 'advanced-active' );
				triggerSearchToggle.innerHTML = `Close Advanced Search <span class="glyphicon glyphicon-minus-sign" aria-hidden="true"></span>`;
			}

			triggerSearchToggle.addEventListener( 'click', function( e ) {
				e.preventDefault();

				if ( searchForm.classList ) {
					let glyphicon = triggerSearchToggle.children[ 0 ];

					searchForm.classList.toggle( 'advanced-active' );
					glyphicon.classList.toggle( 'glyphicon-plus-sign' );
					glyphicon.classList.toggle( 'glyphicon-minus-sign' );
				}

				if ( searchForm.classList.contains( 'advanced-active' ) ) {
					triggerSearchToggle.innerHTML = `Close Advanced Search <span class="glyphicon glyphicon-minus-sign" aria-hidden="true"></span>`;

					localStorage.setItem( 'advancedSearchActive', 'yes' );
				} else {
					triggerSearchToggle.innerHTML = `Advanced Search <span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span>`;
					localStorage.removeItem( 'advancedSearchActive' );
				}
			} );
		}

		function togglePinnedResults() {
			let triggerPinnedToggle = document.getElementById( 'btn-priority-toggle' ),
			    searchForm          = document.querySelector( '.priority-posts-wrapper' );
			if ( triggerPinnedToggle === null ) {
				return;
			}

			triggerPinnedToggle.addEventListener( 'click', function( e ) {
				e.preventDefault();
				if ( searchForm.classList ) {
					searchForm.classList.toggle( 'hidden' );
				}
			} );
		}
	}
)( jQuery );

